<div class="modal-header">
  <h5 class="w-100">
    <strong>Parametri Analitici ammessi</strong>
  </h5>
</div>

<div class="modal-body">
  <div class="scrollable-div">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

    <table mat-table [dataSource]="parametri" class="w-100" *ngIf="!loading">
      <ng-container matColumnDef="codice">
        <th mat-header-cell *matHeaderCellDef>Codice</th>
        <td mat-cell *matCellDef="let row">{{ row.codice }}</td>
      </ng-container>

      <ng-container matColumnDef="tipologia">
        <th mat-header-cell *matHeaderCellDef>Tipologia</th>
        <td mat-cell *matCellDef="let row">{{ row.tipologia }}</td>
      </ng-container>

      <ng-container matColumnDef="obbligatorio">
        <th mat-header-cell *matHeaderCellDef>Obbligatorio</th>
        <td mat-cell *matCellDef="let row">{{ row.obbligatorio ? 'Sì' : 'No' }}</td>
      </ng-container>

      <ng-container matColumnDef="range_consentito">
        <th mat-header-cell *matHeaderCellDef>Range consentito</th>
        <td mat-cell *matCellDef="let row">{{ row.range_consentito }}</td>
      </ng-container>

      <ng-container matColumnDef="unita_misura">
        <th mat-header-cell *matHeaderCellDef>Unità di misura</th>
        <td mat-cell *matCellDef="let row">{{ row.unita_misura | unitaMisura }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
  </div>
</div>

<div class="d-flex justify-content-end align-items-center mt-3">
  <button mat-button (click)="close()">Chiudi</button>
</div>
